<template>
    <!-- flex-column -->
    <div class="home flex-column">
        <div class="banner" :class="{ 'scale': scale >= 1.5 }">
            <!-- <img src="../../assets/new/banner2.png" alt=""> -->
            <el-carousel class="swiper-news" arrow="never" ref='carousel'>
                <el-carousel-item v-for="(item, index) in imgList" :key="index">
                    <img :src="item.image" alt="" @click="goDetail(item)">
                </el-carousel-item>
            </el-carousel>
        </div>
        <Header v-if="!hideHeader" :ref="'header'"></Header>
        <newbreadcrumb v-show="$route.meta.bread"></newbreadcrumb>
        <!-- <breadCrumb v-show="$route.meta.bread"></breadCrumb> -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" class="router-view"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" class="router-view"></router-view>
        <Footer></Footer>
        <el-backtop :right="70" :bottom="100">
            <div class="backtop-inner">
                <img class="bakctop-btn" src="@/assets/home-page/backtop.png" alt="">
            </div>
        </el-backtop>
    </div>
</template>
<script>
import newbreadcrumb from '../components/common/newbreadcrumb.vue'
export default {
    data() {
        return {
            hideHeader: false,
            imgList: [],
            scale: 1
        }
    },
    components: {
        newbreadcrumb
    },
    methods: {
        async getBanners() {
            let resData = await Api.Home.getBanners({
                type: 1
            })
            // console.log('getBanners', resData);
            this.imgList = resData.data;
        },
        goDetail(item) {
            console.log('event', item);
            if (item.url) {
                window.open(item.url)
            } else if (item.name == '操作手册') {
                if (sessionStorage.getItem('token')) {
                    let routeData = this.$router.resolve({ path: '/handbook' });
                    window.open(routeData.href, '_blank');
                } else {
                    this.$refs.header.login('banner');
                }
            }

            // this.$router.push(`news/detail/${event.id}`)
        },
    },
    mounted() {
        this.getBanners()
        // console.log(this.$route.path);
        if (this.$route.path == '/home/business') {
            this.hideHeader = true
        }
        this.scale = window.devicePixelRatio;
    }
}
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    background: #fff;
    position: relative;
    padding-bottom: 300px;

    .banner {
        width: 100%;
        height: 420px !important;

        /deep/ .el-carousel {
            height: 100%;

            .el-carousel__container {
                height: 100%;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

    }

    @media screen and (max-width:1440px) {
        .banner {
            width: 100%;
            height: 400px !important;

            /deep/ .el-carousel {
                height: 100%;

                .el-carousel__container {
                    height: 100%;
                }
            }
        }
    }

    @media screen and (max-width:1330px) {
        .banner {
            width: 100%;
            height: 400px !important;

            /deep/ .el-carousel {
                height: 100%;

                .el-carousel__container {
                    height: 100%;
                }
            }
        }

        .scale {
            height: 100vh !important;
        }
    }
}

@media screen and (max-width: 600px) {
    .home {
        width: 1200px;
        background: #fff;
        position: relative;
        padding-bottom: 300px;

        .banner {
            width: 100%;
            height: 300px !important;

            /deep/ .el-carousel {
                height: 100%;

                .el-carousel__container {
                    height: 100%;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

        }
    }
}
</style>